export enum mensajesModalRnec {
    procesando = 'Estamos validando los datos con la Registraduría Nacional.',
    limiteIntentos = 'Usted excedió el número de intentos permitidos, intente más tarde',
    confirmarAfiliacion = 'Los datos se confirmaron. Continúa con el proceso de afiliación.',
    edadSupera23 = 'La persona que intentas afiliar supera los 23 años. Los beneficiarios tipo hijo(a), hijastro(a) o hermano(a) no deben sobrepasar esta edad.',
    datosConfirmados = 'Los datos se confirmaron. El proceso ha finalizado de forma correcta.',
    datosParaDoc = 'No se pudo confirmar la identidad por favor agrege los documentos solicitados',
}
